import { ChevronDown } from "lucide-react";
import { useState } from "react";

const faqs = [
  {
    question: "How much does a mobile mechanic cost on the Gold Coast?",
    answer: "Mobile mechanic services on the Gold Coast typically range from $250–$600 depending on the service required. With Mobile Car Servicing Gold Coast, a standard logbook service for a 4-cylinder vehicle starts from $250, while brake repairs range between $180–$450. Pre-purchase inspections generally cost $200–$350. Choosing Mobile Car Servicing Gold Coast means we come directly to your location in Southport, Surfers Paradise, Burleigh, or anywhere across the Gold Coast - saving you valuable time and often money compared to traditional workshops."
  },
  {
    question: "Do you service all areas of the Gold Coast?",
    answer: "Yes! We offer Mobile Car Servicing Gold Coast across all suburbs, including Southport, Surfers Paradise, Broadbeach, Burleigh Heads, Robina, Varsity Lakes, Palm Beach, Coolangatta, Coomera, and everywhere in between. Our Mobile Car Servicing Gold Coast team comes straight to your home, office, or preferred location with a fully equipped mobile workshop, making car servicing easy and stress-free."
  },
  {
    question: "Will a mobile mechanic service maintain my new car warranty?",
    answer: "Absolutely! Our Mobile Car Servicing Gold Coast mechanics are fully qualified with Australian certifications (Certificate III & IV in Automotive Technology) and carry out logbook services that meet all manufacturer requirements. With Mobile Car Servicing Gold Coast, we use quality parts and oils that meet or exceed manufacturer specifications, stamp your logbook, and provide detailed service records to help protect your new car warranty."
  },
  {
    question: "How quickly can you come to my location on the Gold Coast?",
    answer: "We offer same-day and next-day appointments across the Gold Coast in most cases. With Mobile Car Servicing Gold Coast, urgent repairs such as battery replacements or breakdown assistance can often be completed within 2-4 hours. For scheduled services like logbook servicing or pre-purchase inspections, Mobile Car Servicing Gold Coast works around your schedule - whether at your home in Robina, your office in Southport, or a seller's location for vehicle inspections."
  },
  {
    question: "What payment methods do you accept for mobile mechanic services?",
    answer: "We accept all major payment methods, including cash, credit and debit cards, bank transfer, and EFTPOS. With Mobile Car Servicing Gold Coast, payment is only due once the job is completed, and you'll receive a clear, detailed invoice for all work carried out. Before we begin, Mobile Car Servicing Gold Coast provides a free quote so you know exactly what to expect - no hidden fees, just honest and transparent pricing for our Gold Coast customers."
  }
];

export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-12 lg:py-20 bg-card/30 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-muted-foreground">
            Everything you need to know about our mobile mechanic services on the Gold Coast
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-card rounded-xl border border-border overflow-hidden transition-all hover:shadow-lg"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left transition-colors hover:bg-muted/50"
                aria-expanded={openIndex === index}
              >
                <h3 className="text-lg font-semibold text-foreground pr-8">
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`w-5 h-5 text-primary flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96" : "max-h-0"
                }`}
              >
                <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-4">
            Still have questions? We're here to help!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+61440134765"
              className="inline-flex items-center justify-center px-6 py-3 bg-primary text-primary-foreground rounded-lg font-semibold hover:opacity-90 transition-opacity"
            >
              Call +61 440 134 765
            </a>
            <a
              href="mailto:info@carguroo.com.au"
              className="inline-flex items-center justify-center px-6 py-3 bg-card border border-border text-foreground rounded-lg font-semibold hover:bg-muted/50 transition-colors"
            >
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export const faqSchemaData = faqs.map(faq => ({
  question: faq.question,
  answer: faq.answer
}));
